import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';
export class StripeConnectedAccountService {

  static async update(id, propertyId, connectedAccountId, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation STRIPECONNECTEDACCOUNT_UPDATE(
          $id: String!
          $data: StripeConnectedAccountInput!
          $propertyId: String!
          $connectedAccountId: String!
        ) {
          stripeConnectedAccountUpdate(id: $id, propertyId: $propertyId, connectedAccountId: $connectedAccountId, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        propertyId,
        connectedAccountId,
      },
    });

    return response.data.stripeConnectedAccountUpdate;
  }

  static async create(propertyId, subpropertyId, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation STRIPECONNECTEDACCOUNT_CREATE(
          $data: StripeConnectedAccountInput!
          $propertyId: String!
          $subpropertyId: String!
        ) {
          stripeConnectedAccountCreate(data: $data, propertyId: $propertyId, subpropertyId: $subpropertyId) {
            id
          }
        }
      `,

      variables: {
        data,
        propertyId,
        subpropertyId,
      },
    });

    return response.data.stripeConnectedAccountCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation STRIPECONNECTEDACCOUNT_IMPORT(
          $data: StripeConnectedAccountInput!
          $importHash: String!
        ) {
          stripeConnectedAccountImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.stripeConnectedAccountImport;
  }

  static async find(id, propertyId) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPECONNECTEDACCOUNT_FIND($propertyId: String!, $id: String!) {
          stripeConnectedAccountFind(propertyId: $propertyId, id: $id) {
            id
            phone {
              prefix
              number
            }
            stripeConnectedAccountId
            country
            created
            defaultCurrency
            settings {
              paymentsStatementDescriptor
              payoutsScheduleDelayDays
              payoutsScheduleInterval
              payoutsScheduleMonthlyAnchor
              payoutsScheduleWeeklyAnchor
              payoutsStatementDescriptor
            }
            tosAcceptance {
              date
              ip
            }
            email
            address {
              line1
              line2
              postalCode
              city
              state
              country
            }
            businessType
            productDescription
            payoutsEnabled
            chargesEnabled
            companyName
            taxIdProvided
            mcc
            firstName
            lastName
            birthdate {
              day
              month
              year
            }
            ssnLast4Provided
            createdAt
            updatedAt
            url
          }
        }
      `,

      variables: {
        propertyId,
        id,
      },
    });

    return response.data.stripeConnectedAccountFind;
  }

  static async getPersonsOverview(id, propertyId) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPECONNECTEDACCOUNT_FIND($propertyId: String!, $id: String!) {
          stripeConnectedAccountPersonsOverview(propertyId: $propertyId, id: $id) {
            hasAccountOpener
            currentOwnershipPercentage
          }
        }
      `,

      variables: {
        propertyId,
        id,
      },
    });

    return response.data.stripeConnectedAccountPersonsOverview;
  }

  static async list(propertyId, filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPECONNECTEDACCOUNT_LIST(
          $propertyId: String!
          $filter: StripeConnectedAccountFilterInput
          $orderBy: StripeConnectedAccountOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          stripeConnectedAccountList(
            propertyId: $propertyId
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              settings {
                paymentsStatementDescriptor
                payoutsScheduleDelayDays
                payoutsScheduleInterval
                payoutsScheduleMonthlyAnchor
                payoutsScheduleWeeklyAnchor
                payoutsStatementDescriptor
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        propertyId,
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.stripeConnectedAccountList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPECONNECTEDACCOUNT_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          stripeConnectedAccountAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.stripeConnectedAccountAutocomplete;
  }

  static async connectedAccountBySubpropertyId({ subpropertyId }) {
    const response = await graphqlClient.query({
      query: gql`
        query SUBPROPERTY_STRIPE_DATA(
          $subpropertyId: String!
        ) {
          stripeSubpropertyDataFind(
            subpropertyId: $subpropertyId
          ) {
            connectedAccount {
              id
              payoutsEnabled
              chargesEnabled
              chargesEnabled
              companyName
              productDescription
              requirements {
                disabledReason
                currentlyDue
                eventuallyDue
                pastDue
                pendingVerification
              }
            }
            subproperty {
              paymentsEnabled
              logo {
                publicUrl
              }
            }
          }
        }
      `,

      variables: {
        subpropertyId
      },
    });
    return response.data.stripeSubpropertyDataFind.connectedAccount;
  }
}
